<template>
  <a class="floating-container" @click="$emit(`click`)">
    <div class="floating-button">
      <font-awesome-icon :icon="icon"/>
    </div>
  </a>
</template>
<script>
export default {
  name: 'FloatingActionButton',
  props : {
    icon : {
      type : String,
      required : false,
      default : 'add'
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto");

.floating-container {
  position: fixed;
  width: 50px;
  height: 50px;
  top: 0;
  left: 0;
  margin: 35px 0;
}

.floating-container .floating-button {
  position: absolute;
  width: 50px;
  height: 50px;
  background: rgb(55, 177, 198);
  bottom: 0;
  border-radius: 50%;
  left: -19px;
  right: 0;
  margin: auto;
  color: white;
  line-height: 50px;
  text-align: center;
  font-size: 23px;
  box-shadow: 0 10px 25px -5px rgba(44, 179, 240, 0.6);
  cursor: pointer;
}
</style>